export const PAGE = {
    SET_NEW_TITLE: 'PAGE.SET_NEW_TITLE'
}